import React from 'react';
import {
  Paper,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  IconButton,
  Avatar,
  Tooltip,
  Box
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { Edit } from '@mui/icons-material';
// import { formatDate } from '../../../../resources/functions';
import { FortuneWheelConfigData } from '../../../../redux/slices/fortuneWheelConfigSlice';

interface FortuneWheelConfigTableProps {
  config: FortuneWheelConfigData;
  onEdit?: (config: FortuneWheelConfigData) => void;
}

const FortuneWheelConfigTable: React.FC<FortuneWheelConfigTableProps> = ({
  config,
  onEdit
}) => {
  const theme = useTheme();
  
  const headerCellStyle = {
    backgroundColor: theme.palette.mode === 'dark' ? '#2A2A2A' : '#F5F5F5',
    color: theme.palette.mode === 'dark' ? '#FFFFFF' : '#424242',
    fontWeight: 600
  };
  
  const renderPartnerCompany = () => {
    if (config.partnerCompany && typeof config.partnerCompany === 'object') {
      const partner = config.partnerCompany as {
        _id: string;
        name: string;
        logo?: string;
      };
      return (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          {partner.logo && partner.logo.startsWith('uploads/') && (
            <Avatar
              src={`/public/${partner.logo}`}
              alt={partner.name}
              sx={{ width: 24, height: 24, mr: 1 }}
            />
          )}
          <span>{partner.name}</span>
        </div>
      );
    }
    return <span>{config.partnerCompany}</span>;
  };

  return (
    <TableContainer sx={{ mt: 3 }} component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            {/* <TableCell sx={headerCellStyle}>Місто</TableCell> */}
            <TableCell sx={headerCellStyle}>Назва</TableCell>
            <TableCell sx={headerCellStyle}>Ціна бонусних балів</TableCell>
            <TableCell sx={headerCellStyle}>Активовано</TableCell>
            <TableCell sx={headerCellStyle}>Партнерська компанія</TableCell>
            {/* <TableCell sx={headerCellStyle}>Дата створення</TableCell>
            <TableCell sx={headerCellStyle}>Дата оновлення</TableCell> */}
            <TableCell sx={headerCellStyle}></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow hover>
            {/* <TableCell>{config.city}</TableCell> */}
            <TableCell>{config.name}</TableCell>
            <TableCell>{config.bonusPointsPrice}</TableCell>
            <TableCell>{config.enabled ? 'Так' : 'Ні'}</TableCell>
            <TableCell>{renderPartnerCompany()}</TableCell>
            {/* <TableCell>{config.createdAt ? formatDate(config.createdAt) : '-'}</TableCell>
            <TableCell>{config.updatedAt ? formatDate(config.updatedAt) : '-'}</TableCell> */}
            <TableCell>
              <Box sx={{ display: 'flex', gap: 0.5, justifyContent: 'flex-end' }}>
                <Tooltip title='Редагувати'>
                  <IconButton
                    size='medium'
                    onClick={() => onEdit && onEdit(config)}
                    sx={{
                      bgcolor: theme.palette.mode === 'light' ? '#F5F5F5' : '#424242',
                      color: theme.palette.mode === 'light' ? '#616161' : '#FFF',
                      borderRadius: '8px',
                      '&:hover': { bgcolor: theme.palette.mode === 'light' ? '#E0E0E0' : '#3A3A3A' }
                    }}
                  >
                    <Edit fontSize='small' />
                  </IconButton>
                </Tooltip>
              </Box>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default FortuneWheelConfigTable;
